import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


const Accordion = ({item, isIDActive, setIDActive}) => {
  const isActive = item.id === isIDActive;  
  const ToggleClass = (id) => {
    
      setIDActive(isActive ? null : item.id);
    };

    return <div  className={isActive ? "active accordion-wrapper" : "inactive accordion-wrapper"} onClick={ToggleClass}>
            <div className='title-wrapper accordion-header' id='id'>
            <h4>
                 <Link activeClassName="cve" to={`/vulnerability/${item.enisaId.aliases.split('\n')[0]}`}>
                   {item.enisaId.aliases.split('\n')[0]}
                 </Link>
               </h4>
              <div className='more-info-button'>
                 {isActive ? <p >Hide information</p> : <p >More information</p>}
  
              </div>
            </div>
            <div className='accordion-content'>
              <div className='score-container'>
                <div className={`score ${item.enisaId.baseScore && 'score-' + Math.round(item.enisaId.baseScore)}`}>
                  <p className='score-data'><strong>
                    {item.enisaId.baseScoreVersion ? <span>CVSS Base Score: {item.enisaId.baseScore ? <span>{item.enisaId.baseScore}</span> : <span>CVSS Not available</span>} (v{item.enisaId.baseScoreVersion})</span> : <span></span>}
                    </strong>
                    <span className="cvss-vector">
                      {item.enisaId.baseScoreVector && item.enisaId.baseScoreVersion && item.enisaId.baseScoreVersion !== "2.0" && (
                        <a
                          href={`https://www.first.org/cvss/calculator/${item.enisaId.baseScoreVersion}#${item.enisaId.baseScoreVector}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          ({`${item.enisaId.baseScoreVector}`})
                        </a>
                      )}
                    </span>
                  </p>
                </div>
              </div>
              
              <div className='summary-wrapper'>
                <h5>Summary</h5>
                <p className="label">{item.enisaId.description}</p>
              </div>
              {/*<div className='affected-products-wrapper'>
                <h5>Affected Product</h5>
                <div className="info">
                  <div className="products"><p className="label">Vendor:</p><ul>{
                                           
                    }
  
                    </ul></div>
                  <div className="products"><p className="label">Products:</p><ul>{}
                  
                    </ul></div>
                  <div className="products version"><p className="label">Version:</p><ul>{}
                  
                    </ul></div>
                </div>
              </div>*/}
              <div className='id-information-wrapper no-flex'>
                 <div className='title-wrapper'>
                   <h5>Advisory IDs <span className='counter'>{}</span></h5>
                 </div>
                  
                <ul className="section-container">
                 <Link activeClassName="cve" to={`/vulnerability/${item.enisaId.id}`}>
                   {item.enisaId.id}
                 </Link>
                 
                </ul>
              </div>
              <div className='references-wrapper'>
                 <div className='title-and-note'>
                   <h5>References 
                     <em className='small-text'>(ENISA is not responsible for the content provided by external links)</em>
                   </h5>
                 </div>
                 <ul>
                    {item.enisaId.references.split('\n').map((item , index) => (
                      <li>
                        <Link activeClassName="referencesLink" target='_blank' to={`${item}`}>{item}</Link>
                      </li>
                    ))}                    
                  </ul>
              </div>
            </div>
         </div>
  }

  export default Accordion;